import React from 'react';
import cn from 'classnames';
import Calendar, {
  CalendarValue,
  CalendarExtraProps,
} from '../../../../../../../components/common/calendar';
import { Visibility } from '../../../../../../../types/common-types';
import './style.scss';

interface Props {
  id: string;
  title?: string;
  value: CalendarValue;
  extra?: CalendarExtraProps;
  error?: boolean;
  errorMsg?: string;
  helpMsg?: string;
  visibility?: Visibility;
  onChange?: (value: { id: string; value: object; error: boolean }) => void;
}

const CalendarBF: React.FC<Props> = ({
  id,
  title,
  value,
  visibility,
  extra,
  errorMsg,
  helpMsg,
  error,
  onChange,
}) => {
  return (
    <Calendar
      id={id}
      styleName={cn('calendar')}
      label={title}
      extra={extra}
      visibility={visibility}
      value={value}
      error={error}
      helperText={error ? errorMsg : helpMsg}
      onChange={onChange}
    />
  );
};
export default CalendarBF;
